<script setup lang="ts">
import { cn } from "@/utils/libs/tailwind-utils";

import BaseLayoutBreadcrumb, {
  type TCustomBreadcrumbRouteFormatter,
} from "@/components/layout/base-layout-breadcrumb.vue";
import BaseTitle from "@/components/layout/base-title.vue";

interface IProps {
  title?: string | null;
  subtitle?: string;
  isLoading?: boolean;
  breadcrumbFormatter?: TCustomBreadcrumbRouteFormatter;
  fullBleed?: boolean;
  hideBreadcrumb?: boolean;
}

const props = defineProps<IProps>();
</script>

<template>
  <div :class="cn('flex h-full w-full flex-col', { 'px-8 pt-8': !props.fullBleed })">
    <div
      v-if="!props.hideBreadcrumb"
      class="base-layout-breadcrumb-row flex w-full shrink-0 items-start justify-between"
    >
      <BaseLayoutBreadcrumb
        class="!p-0 shrink-0"
        :formatter="props.breadcrumbFormatter"
      />
      <slot name="breadcrumbRight" />
    </div>

    <BaseTitle
      v-if="props.isLoading"
      :is-loading="props.isLoading"
    />

    <BaseTitle
      v-else-if="props.title"
      :subtitle="props.subtitle"
      :title="props.title"
    >
      <slot name="titleRight" />
    </BaseTitle>

    <slot />
  </div>
</template>
